const ComingSoonOverlay = () => {
    return (
        <div className="coming-soon-alert-overlay">
            <p className="coming-soon-alert-text">Coming Soon ...</p>
        </div>
    );
}

export default ComingSoonOverlay;